import React from 'react';
import cn from 'classnames';

import Icon from '../Icon';
import useSettingsDropdown from './useSettingsDropdown';

import './settingsDropdown.scss';

interface Props {
    title: string;
    stub:
        | {
              width?: number;
              height?: number;
              glyph: {
                  id: string;
                  content: string;
                  viewBox: string;
              };
          }
        | { element: JSX.Element };
}

const SettingsDropdown: React.SFC<Props> = ({ title, children, stub }) => {
    const { isOpen, toggle, container } = useSettingsDropdown();

    return (
        <div
            ref={container}
            styleName={cn('container', { 'is-open': isOpen })}
            title={title}
        >
            <div
                styleName="stub"
                className="__app-SettingsDropdown-stub"
                onClick={toggle}
            >
                {'element' in stub ? (
                    stub.element
                ) : (
                    <Icon
                        glyph={stub.glyph}
                        styleName="icon"
                        width={stub.width}
                        height={stub.height}
                    />
                )}
                <div styleName="caret" />
            </div>
            {isOpen && children}
        </div>
    );
};

export default SettingsDropdown;
